const { Core, Utils, onBlazeLoad } = Global;
const { $hide, $replaceContent, $toggleDisplay } = Utils;

const ACTIVE_CLASSNAME = 'blaze-active';

function _activeToggle(state) {
    const action = state ? 'add' : 'remove';
    return (el) => {
        el.classList[action](ACTIVE_CLASSNAME);
    }
}

customElements.define('slideshow-inline-blaze', class extends Core {
    elements = {
        $: ['blaze', 'slides-wrapper', ['nav']]
    }

    propTypes = {
        gap: String,
        'slides-per-view': Number,
        'slides-per-view-mobile': Number,
        'slide-by-row': Boolean,
        'swipe-on-desktop': Boolean,
        'track-active': Boolean,
        'inert': Boolean,
        loop: Boolean,
        'autoplay-speed': Number,
        'autoplay-delay': Number,
        'transition-duration': Number
    }

    render() {
        // if slieshow is interted, it will avtivate only on reset. Handy for dynamically loaded content
        if(this.prop('inert')) {
            return;
        }

        onBlazeLoad(this._initBlaze.bind(this));
    }

    destroy() {
        this._clearDelayedAutoplay();
        if(this.slider) {
            this.slider.destroy();
        }
    }

    replaceSlides(slides) {
        this.$('slides-wrapper').replaceChildren(...slides);
        this.reset();
    }

    reset() {
        if(!this.slider) {
            this.removeAttribute('inert');
            this._initBlaze();
        }
        this.slider.totalSlides = this.slider.slides.length;
        this.slider.refresh();
        this._toggleNavigation();
    }

    _initBlaze() {
        if(!window.BlazeSlider) {
            // sanity check
            return;
        }

        const allOptions = {
            slideGap: this.prop('gap'),
            loop: this.prop('loop'),
            slidesToShow: this.prop('slides-per-view'),
            slidesToScroll: this.prop('slide-by-row') ? this.prop('slides-per-view') : 1,
            draggable: this.prop('swipe-on-desktop')
        }

        if(!!this.prop('transition-duration')) {
            allOptions.transitionDuration = this.prop('transition-duration');
        }

        const autoplaySpeed = this.prop('autoplay-speed');
        const autoplayDelay = this.prop('autoplay-delay');

        if(!!autoplaySpeed) {
            allOptions.enableAutoplay = !autoplayDelay;
            allOptions.autoplayInterval = autoplaySpeed;
            allOptions.stopAutoplayOnInteraction = false;
        }

        this.slider = new window.BlazeSlider(this.$('blaze'), {
            all: allOptions,
            '(max-width: 992px)': {
                slidesToShow: this.prop('slides-per-view-mobile'),
                slidesToScroll: 1,
                draggable: true
            }
        })

        if(autoplaySpeed && autoplayDelay) {
            this._startDelayedAutoplay(autoplaySpeed, autoplayDelay);
        }

        if(this.prop('track-active')) {
            this._handleActiveSlides();
        }
        this._toggleNavigation();
    }

    _startDelayedAutoplay(interval, delay) {
        this._clearDelayedAutoplay();
        this._autoplayDelayTimer = window.setTimeout(() => {
            if(!this.slider) return;
            this.slider.next();
            this._autoplayIntervalTimer = window.setInterval(() => this.slider?.next(), interval);
        }, delay);
    }

    _clearDelayedAutoplay() {
        window.clearTimeout(this._autoplayDelayTimer);
        window.clearInterval(this._autoplayIntervalTimer);
        this._autoplayDelayTimer = null;
        this._autoplayIntervalTimer = null;
    }

    _handleActiveSlides() {
        this.$slides = Array.from(this.slider.slides);
        this._setInitialActiveSlides();
        this.slider.onSlide(this._updateActiveSlides.bind(this));
    }

    _setInitialActiveSlides() {
        const [start, end] = this.slider.states[0].page;
        this.activeSlides = this._findSlidesInRange(start, end);
        this._toggleActiveSlides(true);
    }

    _toggleActiveSlides(state) {
        this.activeSlides.map(_activeToggle(state));
    }

    _findSlidesInRange(start, end) {
        return this.$slides.filter((_, i) => start <= i && end >= i);
    }

    _updateActiveSlides(_, start, end) {
        this._toggleActiveSlides(false);
        this.activeSlides = this._findSlidesInRange(start, end);
        this._toggleActiveSlides(true);
    }

    _toggleNavigation() {
        this.$('nav')?.map(item => $toggleDisplay(item, this.hasOffset));
    }

    get hasOffset() {
        return this.slider.totalSlides > this.prop('slides-per-view');
    }
})
